import React from 'react';
import { Link } from 'react-router-dom';
import heroImage from '../Assets/Two_Eyebrows_Black.jpg';
import studioImage from '../Assets/powder_brows_near_me.png';
import useSiteContent from '../hooks/useSiteContent';
import { siteLinks } from '../content/siteContent';

export default function HomePage() {
  const { siteContent } = useSiteContent();

  return (
    <main className="page page--home">
      <section className="hero-section">
        <div className="hero-section__content">
          <span className="section-heading__eyebrow">{siteContent.hero.eyebrow}</span>
          <h1>{siteContent.hero.title}</h1>
          <p>{siteContent.hero.text}</p>

          <div className="badge-row">
            {siteContent.hero.badges.map((badge) => (
              <span key={badge} className="badge-pill">
                {badge}
              </span>
            ))}
          </div>

          <div className="action-row">
            <a className="button button--primary" href={siteLinks.bookingUrl} target="_blank" rel="noopener noreferrer">
              {siteContent.common.bookNow}
            </a>
            <Link className="button button--secondary" to="/pricing">
              {siteContent.common.pricing}
            </Link>
          </div>

          <div className="stats-grid">
            {siteContent.hero.stats.map((item) => (
              <div key={item.label} className="stat-card">
                <strong>{item.value}</strong>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="hero-section__visual">
          <img src={heroImage} alt="Brows Jungle hero" className="hero-section__image" />
          <div className="hero-section__floating-card">
            <span>{siteContent.contact.tag}</span>
            <strong>{siteLinks.address2}</strong>
            <p>{siteContent.contact.hours}</p>
            <a href={siteLinks.mapsUrl} target="_blank" rel="noopener noreferrer">
              {siteContent.common.directions}
            </a>
          </div>
        </div>
      </section>

      <section className="page-section">
        <div className="section-heading">
          <span className="section-heading__eyebrow">{siteContent.services.title}</span>
          <h2>{siteContent.home.title}</h2>
          <p>{siteContent.services.text}</p>
        </div>

        <div className="card-grid card-grid--4">
          {siteContent.services.items.map((item) => (
            <Link key={item.to} to={item.to} className="content-card content-card--link">
              <div className="content-card__body">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
                <span className="text-link">{siteContent.common.details}</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="page-section split-grid split-grid--hero">
        <div className="content-card content-card--side-image">
          <img src={studioImage} alt="PMU studio work" className="content-card__image content-card__image--portrait" />
          <div className="content-card__body">
            <span className="section-heading__eyebrow">{siteContent.home.tag}</span>
            <h2>{siteContent.home.title}</h2>
            <p>{siteContent.home.text}</p>
            <div className="stack-grid">
              {siteContent.home.highlights.map((item) => (
                <div key={item.title} className="mini-card">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="page-section">
        <div className="section-heading section-heading--centered">
          <span className="section-heading__eyebrow">{siteContent.home.processTitle}</span>
          <h2>{siteContent.home.processTitle}</h2>
        </div>
        <div className="card-grid card-grid--3">
          {siteContent.home.process.map((item) => (
            <div key={item.title} className="content-card">
              <div className="content-card__body">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="page-section">
        <div className="cta-banner cta-banner--quote">
          <p>“{siteContent.home.quote}”</p>
          <Link to="/contact" className="button button--primary">
            {siteContent.common.contact}
          </Link>
        </div>
      </section>
    </main>
  );
}
